import { ModuleWithProviders, NgModule } from '@angular/core';
import { IonicModule } from 'ionic-angular';
import { CustomSuperTab } from './customsupertab';
import { CustomSuperTabs } from './customsupertabs';
import { CustomSuperTabsToolbar } from './custom-supertabtoolbar';
import { CustomSuperTabsContainer } from './customsupertabscontainer';
import { CustomSuperTabButton } from './custom-super-tab-button';
import { CustomSuperTabsController } from './customsupertabscontroller';


@NgModule({
  declarations: [
    CustomSuperTab,
    CustomSuperTabs,
    CustomSuperTabsToolbar,
    CustomSuperTabsContainer,
    CustomSuperTabButton
  ],
  imports: [
    IonicModule
  ],
  exports: [
    CustomSuperTab,
    CustomSuperTabs
  ]
})
export class CustomSuperTabsModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: CustomSuperTabsModule,
      providers: [
        CustomSuperTabsController
      ]
    };
  }
}
